import { TaskT } from 'ui-io/task-io/task-t'

export type BooleanKey = 'isAssigned'

const booleanExtractors: Record<
  BooleanKey,
  (task: TaskT) => boolean | undefined | null
> = {
  isAssigned: (task: TaskT) => task.isAssigned,
}

export default booleanExtractors
